import React from 'react';

import type { FacebookPostComponentsProps } from './types';

export function Footer(_props: FacebookPostComponentsProps): React.JSX.Element {
	return <div>Facebook Post Footer</div>;
}
